import { jsx as n, jsxs as E } from "react/jsx-runtime";
import C, { useState as w, useEffect as U, useMemo as j } from "react";
import { u as d } from "./index-6a632112.mjs";
import { s as k, Q as h, r as A, o as $, j as g, i as u, m as S, e as a } from "./themes-5f0b3c3d.mjs";
import { S as X } from "./cancelClose-87fdf326.mjs";
import { S as D } from "./checkmark-84b5274e.mjs";
import { S as F } from "./edit-054ba80e.mjs";
import { useWindowDimensions as G } from "./useWindowDimensions.js";
import "./types-b577bf77.mjs";
const M = `
  font-family: ${a.medium.M.fontFamily};
  font-weight: ${a.medium.M.fontWeight};
  font-size: ${a.medium.M.fontSize};
  line-height: ${a.medium.M.lineHeight};
`, H = `
  font-family: ${a.medium.XS.fontFamily};
  font-weight: ${a.medium.XS.fontWeight};
  font-size: ${a.medium.XS.fontSize};
  line-height: ${a.medium.XS.lineHeight};
`, I = d.div`
  display: flex;
  flex-direction: column;
  flex-grow: ${({ $isVisible: e }) => e ? 0 : 1};
  height: ${({ $isLastStep: e, $isVisible: i }) => i || e ? "unset" : "100%"};
`, O = d.div`
  display: flex;
  gap: ${k["2x"]};
  align-items: center;
  width: max-content;
  @media ${h.tabletAndUp} {
    gap: ${k["4x"]};
  }
`, Q = d.div`
  width: 24px;
  height: 24px;
  border-radius: ${A["8x"]};
  box-sizing: border-box;
  border: 2px solid
    ${(e) => e.$error && e.$isActive ? $.danger : e.$editable ? g["primary-strong"] : e.$error ? $.danger : e.$isActive || e.$isCompleted ? g["primary-strong"] : $["neutral-moderate"]};
  background-color: ${(e) => e.$error && e.$isActive ? g["danger-strong"] : e.$isActive || e.$editable ? g["primary-strong"] : "unset"};
  color: ${({ $isActive: e, $editable: i, $isCompleted: o, $error: r }) => i ? u.onColor : r && !e ? S.danger : e ? u.onColor : o ? S.primary : u.placeholder};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color, border-color;
  transition-duration: 0.2s;
  cursor: ${({ $editable: e }) => e ? "pointer" : "default"};
  ${H};
  @media ${h.tabletAndUp} {
    height: 32px;
    width: 32px;
    ${M};
  }
`, R = d.div`
  position: relative;
  left: 11px;
  width: 2px;
  border-radius: ${A["4x"]};
  background-color: ${({ $isActive: e }) => e ? $.focus : $["neutral-moderate"]};
  margin: ${k["1x"]} 0;
  transition: background-color;
  transition-duration: 0.2s;
  @media ${h.tabletAndUp} {
    left: 15px;
  }
`, B = d.div`
  display: flex;
  height: 100%;
`, q = d.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`, J = d.label`
  color: ${({ $isCompleted: e, $editable: i }) => i ? u["primary-strong"] : e ? u.default : u.subtlest};
  cursor: ${(e) => e.$editable ? "pointer" : "default"};
  ${M};
`, K = d.div`
  display: ${({ $isVisible: e }) => e ? "block" : "none"};
  margin: 36px 0 36px 39px;
  width: 100%;
  @media ${h.tabletAndUp} {
    margin-left: 104px;
  }
`, N = ({
  children: e,
  activeStep: i,
  onEdit: o,
  type: r = "progress",
  className: m
}) => {
  const s = C.Children.map(
    e,
    (t, l) => {
      if (C.isValidElement(t) && t.type === W) {
        const f = t.props;
        return C.cloneElement(t, {
          _stepIndex: l + 1,
          activeStep: i,
          onClick: o,
          markerText: r === "progress" ? `${l + 1}` : f?.markerText?.substring(0, 2)
        });
      }
      return null;
    }
  );
  return /* @__PURE__ */ n(q, { className: m, children: s });
}, W = ({
  children: e,
  label: i = "Label",
  _stepIndex: o = 1,
  activeStep: r = 1,
  onClick: m,
  markerText: s = "",
  error: t = !1
}) => {
  const [l, f] = w(o <= r), [c, p] = w(!1), { width: b } = G(), y = b < 600, x = {
    height: y ? 16 : 20,
    width: y ? 16 : 20
  };
  U(() => {
    o <= r && f(!0);
  }, [r]);
  const T = () => {
    !y && o < r && p(!0);
  }, V = () => {
    o <= r && p(!1);
  }, v = (P, z) => {
    o < r && m && m(P, z);
  }, L = j(() => c && o < r ? /* @__PURE__ */ n(F, { ...x }) : t ? /* @__PURE__ */ n(X, { ...x }) : o < r ? /* @__PURE__ */ n(D, { ...x }) : s, [c, o, r, t, s]);
  return /* @__PURE__ */ E(
    I,
    {
      $isVisible: l,
      $isLastStep: !e,
      children: [
        /* @__PURE__ */ n(
          Y,
          {
            markerContent: L,
            error: t,
            editable: c,
            index: o,
            activeStep: r,
            label: i,
            onMouseEnter: T,
            onMouseLeave: V,
            onClick: v
          }
        ),
        /* @__PURE__ */ E(B, { children: [
          e && /* @__PURE__ */ n(R, { $isActive: r > o }),
          /* @__PURE__ */ n(K, { $isVisible: l, children: e })
        ] })
      ]
    }
  );
}, Y = ({
  markerContent: e,
  label: i,
  onMouseEnter: o,
  onMouseLeave: r,
  onClick: m,
  index: s,
  activeStep: t,
  editable: l = !1,
  error: f = !1
}) => {
  const c = t >= s;
  return /* @__PURE__ */ E(
    O,
    {
      onMouseEnter: o,
      onMouseLeave: r,
      onClick: (b) => m(b, s),
      children: [
        /* @__PURE__ */ n(
          Q,
          {
            $isActive: t === s,
            $isCompleted: c,
            $editable: l,
            $error: f,
            children: e
          }
        ),
        /* @__PURE__ */ n(J, { $isCompleted: c, $editable: l, children: i })
      ]
    }
  );
};
N.Step = W;
export {
  N as ProgressTrackerVertical
};
